<div class="card-body">
  <h5 *ngIf="section_title" class="card-title">{{ section_title }}</h5>
  <ng-content></ng-content>
</div>